module.exports = __webpack_public_path__ + "media/img/why/curated-bd202c8b97ba7ebb8b31f24a426e5fed.png";